export default __webpack_public_path__ + "static/media/web_go.0caf3e71.png";